<template>
  <v-flex>
    <v-layout row class="content-header">
      <v-flex md7 class="content-title">
        <v-main
          v-if="corretorHabilitadoPostagemAutomatica"
          style="color: red; font-size: 12px; padding: 0px 120px 0px 0px !important"
        >
          <v-icon class="hover" color="red">mdi-comment-alert</v-icon>
          Apólices sinalizadas como movimentação automática serão realizadas na data de
          corte, em caso de nenhuma ação de movimentação realizada pelo Corretor.
        </v-main>
      </v-flex>
      <v-flex md4>
        <v-text-field
          v-model="termoPesquisa"
          label="Pesquisa"
          outlined
          class="input-pesquisa"
          placeholder="Apólice e Estipulante"
          @keyup.enter="pesquisar()"
        ></v-text-field>
      </v-flex>
      <v-flex md1>
        <!-- &nbsp;<v-btn color="info" @click="pesquisar()"><v-icon>mdi-filter-variant</v-icon></v-btn> -->
        &nbsp;<v-btn color="info" @click="pesquisar()"
          ><v-icon>mdi-magnify</v-icon></v-btn
        >
      </v-flex>
      <v-flex md12>
        <div class="line"></div>
      </v-flex>
    </v-layout>
    <v-layout row class="content-body overflow-y-auto" v-if="visibleList">
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="vidas"
          :loading="loading"
          :search="termoPesquisa"
          loading-text="Carregando... Por favor aguarde."
          no-data-text="Nenhuma informação encontrada"
          no-results-text="Nenhuma informação encontrada"
          :sort-by="['emissaoPendente']"
          :sort-desc="[true]"
          class=""
        >
          <template v-slot:item.apl="{ item }">
            {{ item.apl.indexOf("-") > 10 ? item.apl.split("-")[0] : item.apl }}
          </template>

          <template v-slot:item.sub="{ item }">
            {{ item.apl.indexOf("-") > 10 ? item.apl.split("-")[1] : "-" }}
          </template>

          <template v-slot:item.modulo="{ item }">
            {{ item.apl.indexOf("-") > 10 ? item.apl.split("-")[2] : "-" }}
          </template>

          <template v-slot:item.emissaoPendente="{ item }">
            {{
              [item.emissaoPendente.slice(0, 4), "/", item.emissaoPendente.slice(4)].join(
                ""
              )
            }}
          </template>
          <template v-slot:item.estipulante="{ item }">
            <span v-html="item.estipulante">{{ item.estipulante }}</span>
          </template>

          <template v-slot:item.dataCorte="{ item }">
            {{ FormatarData(item.dataCorte) }}
          </template>

          <template v-slot:item.movimentacaoAutomatica="{ item }">
            <v-checkbox
              v-model="item.movimentacaoAutomatica"
              @change="alterarMovimentacaoAutomatica(item)"
              :disabled="item.checkMovimentacaoAutomatica"
              :indeterminate="item.checkMovimentacaoAutomatica"
              class="text-alert"
            >
              <template v-slot:label>
                <v-icon
                  v-if="item.checkLabelMovimentacaoAutomatica"
                  class="hover"
                  color="red"
                  >mdi-comment-alert</v-icon
                >
              </template>
            </v-checkbox>
          </template>
          <template v-slot:item.opcoes="{ item }">
            <div
              v-if="item.motivoRecusaPostagemAutomatica != null"
              style="padding: 10px; color: red; text-align: center"
            >
              <strong>{{ item.motivoRecusaPostagemAutomatica }}</strong>
            </div>

            <div v-if="item.quantidadeAberto < 2" class="text-center">
              <div
                v-if="item.movimentacaoAutomaticaProcessada == true"
                class="alert info-success enviado"
              >
                <strong>Enviado para movimentação automática</strong>
              </div>

              <div v-if="item.status == 5" class="alert processando">
                <strong>Processando Faturamento</strong> <br />
                <span v-if="item.movimentacaoAutomaticaProcessada == true"
                  ><strong>Movimentação:</strong> Automática<br
                /></span>
                <strong>Protocolo:</strong> {{ item.protocolo }} | <strong>Lote:</strong>
                {{ item.lote }} <strong>Protocolo:</strong> {{ item.protocolo }} <br />
                <strong>Lote:</strong> {{ item.lote }}
                <span v-if="item.totalVida > 0"
                  >| {{ item.totalVida }} <strong>Vidas</strong></span
                >
              </div>

              <div v-if="item.status == 50">
                <strong>Finalizado</strong> <br />
                <span v-if="item.movimentacaoAutomaticaProcessada == true"
                  ><strong>Movimentação:</strong> Automática<br
                /></span>
                <strong>Protocolo:</strong> {{ item.protocolo }}
                <strong>Protocolo:</strong> {{ item.protocolo }} <br />
                <strong>Lote:</strong> {{ item.lote }}
                <span v-if="item.totalVida > 0"
                  >| {{ item.totalVida }} <strong>Vidas</strong></span
                >
              </div>

              <div
                v-if="item.status == 99"
                class="alert alert-error"
                style="cursor: pointer"
                @click="abrirModalErros(item)"
              >
                <strong>Movimentação com erros!</strong> <br />
                <span v-if="item.movimentacaoAutomaticaProcessada == true"
                  ><strong>Movimentação:</strong> Automática<br
                /></span>
                <strong>Algumas vidas presentes nessa movimentação </strong>
                {{ item.protocolo }} <br />
                <strong>Protocolo:</strong> {{ item.protocolo }} <br />
                <span v-if="item.totalVida > 0"
                  >| {{ item.totalVida }} <strong>Vidas</strong></span
                >
                <br />
                <small
                  ><v-icon small>mdi-cursor-default-click</v-icon> Clique para ver
                  detalhes dos erros</small
                >
                <br />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on:click.stop="excluirMovimentacaoDialog(item)"
                      class="hover"
                      v-on="on"
                      style="margin-top: 5px"
                      >mdi-calendar-remove</v-icon
                    >&nbsp;
                  </template>
                  <span>Clique para excluir movimentação</span>
                </v-tooltip>
              </div>

              <div v-if="item.status == 2">
                <strong>Processando Validações</strong> <br />
                <span v-if="item.movimentacaoAutomaticaProcessada == true"
                  ><strong>Movimentação:</strong> Automática<br
                /></span>
                <strong>Protocolo:</strong> {{ item.protocolo }}
                <strong>Protocolo:</strong> {{ item.protocolo }} <br />
                <strong>Lote:</strong> {{ item.lote }}
                <span v-if="item.totalVida > 0"
                  >| {{ item.totalVida }} <strong>Vidas</strong></span
                >
              </div>
              <div v-if="item.status == 8" class="alert faturado">
                <strong>Faturado Automaticamente</strong> <br />
                <strong>Protocolo:</strong> {{ item.protocolo }}
              </div>

              <div v-if="item.status == 50">
                <strong>Finalizado</strong> <br />
                <span v-if="item.movimentacaoAutomaticaProcessada == true"
                  ><strong>Movimentação:</strong> Automática<br
                /></span>
                <strong>Protocolo:</strong> {{ item.protocolo }}
                <strong>Protocolo:</strong> {{ item.protocolo }} <br />
                <strong>Lote:</strong> {{ item.lote }}
                <span v-if="item.totalVida > 0"
                  >| {{ item.totalVida }} <strong>Vidas</strong></span
                >
              </div>

              <div v-if="item.status == 1" class="alert info-success enviado">
                <strong>Arquivo enviado em:</strong>
                {{ item.dataCriacao | formatDateBR }} <br />
                <span v-if="item.movimentacaoAutomaticaProcessada == true"
                  ><strong>Movimentação:</strong> Automática<br
                /></span>
                <strong>Protocolo:</strong> {{ item.protocolo }}
                <strong>Protocolo:</strong> {{ item.protocolo }} <br />
                <span v-if="item.lote != null"
                  ><strong>Lote:</strong> {{ item.lote }}
                </span>
                <span v-if="item.totalVida > 0"
                  >{{ item.totalVida }} <strong>Vidas</strong></span
                >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on:click="excluirMovimentacaoDialog(item)"
                      class="hover"
                      v-on="on"
                      >mdi-calendar-remove</v-icon
                    >&nbsp;
                  </template>
                  <span>Clique para excluir movimentação</span>
                </v-tooltip>
              </div>

              <div v-if="item.status == 4">
                <strong>Aguardando as movimentações dos demais planos</strong> <br />
                <strong>Protocolo:</strong> {{ item.protocolo }}
              </div>

              <div
                v-if="
                  item.status != 1 &&
                  item.status != 4 &&
                  item.status != 5 &&
                  item.status != 8 &&
                  item.status != 50 &&
                  item.status != 99
                "
              >
                <v-tooltip bottom v-if="item.primeiroFaturamento == false">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on:click="semMovimentacaoAbrirDialogo(item)"
                      class="hover"
                      v-on="on"
                      >mdi-calendar-remove</v-icon
                    >&nbsp;
                  </template>
                  <!-- semMovimentacao(item) -->
                  <span>Clique para marcar como sem movimentação</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on:click="showUploadExcel(item)" class="hover" v-on="on"
                      >mdi-cloud-upload</v-icon
                    >
                  </template>
                  <span>Clique para realizar o envio das vidas (Upload)</span>
                </v-tooltip>
                <br />
                <v-flex v-if="item.primeiroFaturamento == true">
                  <strong>Movimentação Obrigatória</strong> <br />
                  <strong>Motivo:</strong> Primeira Emissão
                </v-flex>
              </div>
            </div>
            <div v-if="item.quantidadeAberto >= 2" class="text-center">
              <strong>Movimentação Bloqueada</strong><br />
              <strong>Motivo:</strong> Parcelas em Aberto
            </div>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-layout row class="content-body overflow-y-auto" v-if="visibleUpload">
      <v-flex md4>
        <br />
        <v-select
          :items="tipoRelacaoList"
          v-model="tipoRelacao"
          label="Informe o tipo de relação"
          outlined
        ></v-select>
      </v-flex>
      <v-flex md8></v-flex>
      <v-flex md12>
        <p>
          Caso a apólice seja múltiplo salarial e o valor da cobertura ultrapassar o
          limite máximo, a vida será emitida com o valor máximo permitido em contrato
        </p>
      </v-flex>
      <v-flex md12>
        <v-data-table
          :headers="headersApoliceSelecionada"
          :items="vidasApoliceSelecionada"
          hide-default-footer
          class=""
        >
        </v-data-table>
      </v-flex>
      <v-flex md12>
        Apenas arquivos XLS ou XLSX são aceitos <br />
        <v-btn text small href="/upload/Layout_mov_vidas.xlsx" target="_blank"
          ><strong> Baixe aqui</strong>&nbsp;a planilha modelo</v-btn
        >
      </v-flex>
      <v-flex md4>
        <v-file-input chips v-model="fileExcel" label="Escolha o arquivo"></v-file-input>
      </v-flex>
      <v-flex md4>
        <v-btn v-on:click="uploadExcel()" color="info" style="margin-top: 10px"
          ><v-icon>mdi-cloud-upload</v-icon>&nbsp; Upload do arquivo</v-btn
        >
      </v-flex>
      <v-flex md4 class="text-right">
        <v-btn color="info" style="margin-top: 10px" v-on:click="cancelarUpload()"
          ><v-icon>mdi-close-circle</v-icon>&nbsp; Cancelar upload</v-btn
        >
      </v-flex>
    </v-layout>

    <v-layout row class="content-body overflow-y-auto" v-if="visibleConfiguracaoPlanilha">
      <v-flex md4>
        <br />
        <v-select
          :items="linhasList"
          v-model="linha"
          label="Importar dados a partir da linha:"
          outlined
        ></v-select>
      </v-flex>
      <v-flex md8></v-flex>
      <v-flex md12>
        <v-simple-table class="border">
          <template v-slot:default>
            <thead>
              <tr>
                <th></th>
                <th
                  class="text-left"
                  v-for="(item, index) in tipoColunaList"
                  :key="index"
                >
                  <v-select
                    :items="item.opcoes"
                    v-model="item.value"
                    label="Associe as colunas com o tipo de informação"
                    outlined
                    class="select-tipo-coluna"
                    @change="tipoColunaSelecionada"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in planilhaEnviada.slice(0, 2)" :key="index">
                <td>{{ ++index }}</td>
                <td v-for="(item2, index2) in item" :key="index2">
                  {{ verificarCampoData(item2) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
      <v-flex md6>
        <v-btn color="info" style="margin-top: 10px" v-on:click="cancelarProcessamento()"
          ><v-icon>mdi-close-circle</v-icon>&nbsp; Cancelar e efetuar upload do arquivo
          novamente</v-btn
        >
      </v-flex>
      <v-flex md6 class="text-right">
        <v-btn v-on:click="processarVidas()" color="info" style="margin-top: 10px"
          ><v-icon>mdi-cloud-upload</v-icon>&nbsp; Importar dados</v-btn
        >
      </v-flex>
      <v-flex md12> <br /><br /> </v-flex>
    </v-layout>

    <!-- Modal de Erros das Vidas -->
    <v-dialog v-model="showModalErros" persistent max-width="1200px">
      <v-card>
        <v-overlay :value="loadingModalErros">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card-title>
          <span class="headline">
            <v-icon color="error">mdi-alert-circle</v-icon>
            Vidas com Erros - Apólice: {{ apoliceComErro }}
          </span>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="exportarPDF"
            :disabled="vidasComErro.length === 0"
          >
            <v-icon left>mdi-file-pdf-box</v-icon>
            Exportar PDF
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-divider></v-divider>
          <div style="margin-top: 15px">
            <v-data-table
              :headers="headersVidasComErro"
              :items="vidasComErro"
              :items-per-page="10"
              :loading="loadingModalErros"
              loading-text="Carregando vidas com erro... Por favor aguarde."
              no-data-text="Nenhuma vida com erro encontrada."
              class="elevation-1"
            >
              <template v-slot:item.nome="{ item }">
                <strong>{{ item.nome }}</strong>
              </template>

              <template v-slot:item.cpf="{ item }">
                <span class="text-mono">{{ formatarCPF(item.cpf) }}</span>
              </template>

              <template v-slot:item.sexo="{ item }">
                <v-chip
                  small
                  :color="item.sexo === 'M' ? 'blue' : 'pink'"
                  text-color="white"
                >
                  {{ item.sexo === "M" ? "Masculino" : "Feminino" }}
                </v-chip>
              </template>

              <template v-slot:item.status="{ item }">
                <v-chip small color="error" text-color="white">
                  <v-icon small left>mdi-alert</v-icon>
                  {{ item.status }}
                </v-chip>
              </template>
            </v-data-table>
          </div>
        </v-card-text>

        <v-card-actions>
          <span class="pull-left text-subtitle-2">
            <v-icon small color="error">mdi-account-alert</v-icon>
            Total de vidas com erro: <strong>{{ vidasComErro.length }}</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="fecharModalErros()">
            <v-icon left>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout justify-end>
      <v-dialog
        v-model="showErroLista"
        persistent
        max-width="1000px"
        @click:outside="showErroLista = false"
      >
        <v-card>
          <v-overlay :value="fullLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-card-title>
            <span class="headline">Erros Detectados</span>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <div>
              <!-- CORPO DO MODAL -->
              <v-data-table
                :headers="headersErroLista"
                :items="erroLista"
                :items-per-page="10"
                :loading="loading"
                loading-text="Carregando... Por favor aguarde."
                no-data-text="Sem erros."
                justify="center"
              >
              </v-data-table>
            </div>
          </v-card-text>
          <v-card-actions fixed>
            <span class="pull-left"
              >Total de Registros/Vidas : {{ this.registrosValidos }} Válidos e
              {{ this.registrosInvalidos }} Inválidos
            </span>
            <v-spacer></v-spacer>
            <v-btn color="red" text type="button" @click="showErroLista = false"
              >Fechar</v-btn
            >
            <v-btn
              color="blue"
              text
              type="button"
              v-if="erroLista.length > 0"
              @click="emitirArquivoErro()"
              >Baixar Lista</v-btn
            >
            <v-btn color="green" text type="button" @click="importarDados()"
              >Importar Registros Válidos</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-overlay :value="fullLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="headline">Atenção</v-card-title>

        <v-card-text>
          {{ this.textoDialog }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="dialog = false"> Cancelar </v-btn>

          <v-btn
            v-if="botaoSemMovimentacao"
            color="green darken-1"
            text
            @click="semMovimentacao(aplSelecionada)"
          >
            Ok
          </v-btn>
          <v-btn
            v-if="botaoImportarTodos"
            color="green darken-1"
            text
            @click="importarDados()"
          >
            Importar todos
          </v-btn>
          <v-btn
            v-if="botaoExcluirMovimento"
            color="green darken-1"
            text
            @click="excluirMovimentacao()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import Helpers from "@/utilities/Helpers";
import moment from "moment";
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "portal-corretor-vidas",
  mixins: [Helpers],
  data() {
    return {
      corretorHabilitadoPostagemAutomatica: false,
      dialog: false,
      salvarDados: false,
      textoDialog: "",
      botaoSemMovimentacao: false,
      botaoImportarTodos: false,
      botaoExcluirMovimento: false,
      aplSelecionada: [],
      fullLoading: false,
      fileExcel: null,
      visibleList: true,
      visibleUpload: false,
      visibleConfiguracaoPlanilha: false,

      // Dados para o modal de erros
      showModalErros: false,
      loadingModalErros: false,
      vidasComErro: [],
      apoliceComErro: "",
      headersVidasComErro: [
        { text: "Nome", value: "nome", sortable: true, width: "40%" },
        { text: "CPF", value: "cpf", sortable: true, width: "20%" },
        { text: "Status/Erro", value: "status", sortable: false, width: "40%" },
      ],

      tipoRelacaoList: [
        { text: "Relação Completa", value: 1 },
        { text: "Apenas Movimentação", value: 2 },
      ],
      tipoRelacao: null,
      linhasList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      linha: null,
      termoPesquisa: "",
      numeroColunas: 3,
      loading: true,
      camposObrigatorios: [],
      headers: [],
      headersApoliceSelecionada: [
        { text: "Apólice(s) Selecionada(s)", value: "apl" },
        { text: "Competência", value: "emissaoPendente" },
      ],
      vidas: [],
      vidasApoliceSelecionada: [],
      planilhaEnviada: [],
      tipoColuna: [],
      tipoColunaList: [],
      showErroLista: false,
      erroLista: [],
      headersErroLista: [{ text: "Erros", value: "mensagem" }],
      retornoProcessamento: {},
      registrosValidos: 0,
      registrosInvalidos: 0,
    };
  },
  methods: {
    resetarDialog() {
      this.textoDialog = "";
      this.botaoSemMovimentacao = false;
      this.botaoImportarTodos = false;
      this.botaoExcluirMovimento = false;
      this.dialog = false;
    },

    // Método para abrir o modal de erros
    abrirModalErros(item) {
      this.apoliceComErro = item.apl;
      this.showModalErros = true;
      this.loadingModalErros = true;
      this.vidasComErro = [];

      this.buscarVidasComErros(item.apl);
    },

    // Método para buscar as vidas com erros
    buscarVidasComErros(numeroApolice) {
      let url = `MovimentoVida/listar-vidas-com-erros?numeroApolice=${numeroApolice}`;

      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          this.vidasComErro = res.data;
          this.loadingModalErros = false;
        })
        .catch((error) => {
          console.log("Erro ao buscar vidas com erros:", error);
          this.showToast("error", "Erro!", "Erro ao carregar vidas com erros.");
          this.loadingModalErros = false;
          this.fecharModalErros();
        });
    },

    // Método para fechar o modal de erros
    fecharModalErros() {
      this.showModalErros = false;
      this.vidasComErro = [];
      this.apoliceComErro = "";
    },

    // Método para formatar CPF
    formatarCPF(cpf) {
      if (!cpf) return "";
      const cleanCPF = cpf.replace(/\D/g, "");
      return cleanCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },

    // Método para exportar PDF das vidas com erros
    exportarPDF() {
      if (!this.apoliceComErro) {
        this.showToast(
          "warning",
          "Atenção!",
          "Nenhuma apólice selecionada para gerar o PDF."
        );
        return;
      }

      // Mostrar loading no modal
      this.loadingModalErros = true;

      const numeroApolice = this.apoliceComErro;
      const url = `MovimentoVida/gerar-pdf-vidas-com-erros?numeroApolice=${numeroApolice}`;

      Vue.prototype.$httpPortal
        .get(url)
        .then((response) => {
          const data = response.data;

          if (data.success && data.pdfBase64) {
            const base64Data = data.pdfBase64;
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            const blobUrl = URL.createObjectURL(blob);

            const newWindow = window.open(blobUrl, "_blank");

            if (newWindow) {
              setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
              }, 10000); // 10 segundos

              this.showToast("success", "Sucesso!", "PDF gerado e aberto com sucesso.");
            } else {
              const link = document.createElement("a");
              link.href = blobUrl;
              link.download =
                data.fileName || `vidas-com-erros-apolice-${numeroApolice}.pdf`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl);

              this.showToast(
                "info",
                "Download iniciado",
                "O PDF foi baixado automaticamente."
              );
            }
          } else {
            this.showToast("error", "Erro!", data.message || "Erro ao gerar o PDF.");
          }
        })
        .catch((error) => {
          console.error("Erro ao gerar PDF:", error);
          let errorMessage = "Erro ao gerar o PDF das vidas com erros.";

          if (error.response && error.response.data) {
            errorMessage =
              error.response.data.message || error.response.data || errorMessage;
          }

          this.showToast("error", "Erro!", errorMessage);
        })
        .finally(() => {
          this.loadingModalErros = false;
        });
    },

    semMovimentacaoAbrirDialogo(item) {
      this.verificarMovimentacaoRealizada(item).then((result) => {
        console.log(result);
        if (result == true) {
          this.showToast("warning", "Atenção!", "Essa movimentação já foi realizada");
          return;
        } else {
          this.aplSelecionada = item;
          console.log(this.aplSelecionada);
          this.resetarDialog();
          this.textoDialog =
            "Deseja realmente marcar como Sem Movimentação (Apólice: " +
            this.aplSelecionada.apl +
            ")?";
          this.botaoSemMovimentacao = true;
          this.dialog = true;
        }
      });
    },
    verificarCampoData(texto) {
      texto = String(texto).replace("R$", "");
      if (String(texto).indexOf(",") > -1 && String(texto).indexOf(".") > -1) {
        return texto;
      }

      if (String(texto).indexOf(",") > -1 || String(texto).indexOf(".") > -1) {
        if (isNaN(texto)) return texto;

        return Math.round(parseFloat(texto) * 100) / 100;
      }

      if (texto % 1 === 0) return texto;

      return texto;
    },
    requestVidas() {
      this.ConfirmarExcluirMovimento = false;
      this.salvarDados = false;
      this.visibleUpload = false;
      this.visibleConfiguracaoPlanilha = false;
      this.visibleList = true;
      this.tipoRelacao = null;
      this.linha = null;
      this.tipoCampoData = null;
      this.fileExcel = null;
      this.loading = true;
      this.fullLoading = true;

      let codigoCorretor = this.usuario.codCorretor;
      let url = "MovimentoVida/" + codigoCorretor;

      // Se tiver termo para pesquisa
      if (this.termoPesquisa != "") url += "/" + this.termoPesquisa;
      //console.log(url)

      // Request vidas
      Vue.prototype.$httpPortal
        .get(url)
        .then()
        .then((res) => {
          this.configureHeaders(res.data);
          this.vidas = res.data;

          //console.log("this.vidas")
          //console.log('vidas', this.vidas)

          for (let index in this.vidas) {
            this.vidas[index].checkMovimentacaoAutomatica = !(
              this.vidas[index].mostraFlagPostagemAutomatica == 1 &&
              this.vidas[index].status == null &&
              this.vidas[index].dataCorteVencida == false &&
              this.vidas[index].tipoSistema != "SNGS"
            );
            this.vidas[index].checkLabelMovimentacaoAutomatica =
              this.vidas[index].movimentacaoAutomatica == true &&
              this.vidas[index].status == null &&
              this.vidas[index].dataCorteVencida == false &&
              this.vidas[index].tipoSistema != "SNGS";
            this.vidas[index].movimentacaoAutomatica =
              this.vidas[index].checkLabelMovimentacaoAutomatica == true
                ? this.vidas[index].movimentacaoAutomatica
                : false;
          }

          this.loading = false;
          this.fullLoading = false;
        })
        .catch((ex) => {
          console.log(ex);
          this.loading = false;
          this.fullLoading = false;
        });
    },
    verificarMovimentacaoRealizada(item) {
      return new Promise((resolve, reject) => {
        let codigoCorretor = this.usuario.codCorretor;
        let url =
          "MovimentoVida/verificar-movimentacao/" +
          codigoCorretor +
          "/" +
          item.apl +
          "/" +
          item.emissaoPendente;

        // Verifica se movimentação ja foi realizada
        Vue.prototype.$httpPortal
          .get(url)
          .then()
          .then((res) => {
            resolve(res.data);
          })
          .catch((ex) => {
            reject(new Error(ex));
          });
      });
    },
    pesquisar() {
      this.offset = 1;
      this.requestVidas();
    },
    configureHeaders(value) {
      console.log("REQUESTVIDA > configureHeaders > ");
      console.log(value[0].corretorHabilitadoPostagemAutomatica);
      if (value[0].corretorHabilitadoPostagemAutomatica == 1) {
        this.headers = [
          { text: "Apólice", value: "apl" },
          { text: "Sub", value: "sub" },
          { text: "Módulo", value: "modulo" },
          { text: "Estipulante", value: "estipulante" },
          { text: "Competência", value: "emissaoPendente" },
          { text: "Parc. Abertas", value: "quantidadeAberto" },
          { text: "Data Corte", value: "dataCorte" },
          { text: "Movimentação Automática", value: "movimentacaoAutomatica" },
          { text: "", value: "opcoes", sortable: false },
        ];

        this.corretorHabilitadoPostagemAutomatica = true;
      } else {
        this.headers = [
          { text: "Apólice", value: "apl" },
          { text: "Sub", value: "sub" },
          { text: "Módulo", value: "modulo" },
          { text: "Estipulante", value: "estipulante" },
          { text: "Competência", value: "emissaoPendente" },
          { text: "Parc. Abertas", value: "quantidadeAberto" },
          { text: "Data Corte", value: "dataCorte" },
          { text: "", value: "opcoes", sortable: false },
        ];

        this.corretorHabilitadoPostagemAutomatica = false;
      }
    },
    semMovimentacao(item) {
      console.log(item);
      this.fullLoading = true;
      this.aplSelecionada = [];
      this.resetarDialog();

      let codigoCorretor = this.usuario.codCorretor;
      let numeroSub = item.numeroSub == null ? "null" : item.numeroSub;
      let emailUsuario =
        this.usuario.emailAuxiliar != null && this.usuario.emailAuxiliar != ""
          ? this.usuario.emailAuxiliar
          : this.usuario.email;
      let url =
        "MovimentoVida/sem-movimentacao/" +
        codigoCorretor +
        "/" +
        item.apl +
        "/" +
        numeroSub +
        "/" +
        emailUsuario;

      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          this.showToast("success", "Sucesso!", "Movimentação realizada com sucesso.");
          //console.log(res.data);

          this.fullLoading = false;
          this.requestVidas();
        })
        .catch((error) => {
          this.showToast("error", "Erro!", error.response.data);
          this.fullLoading = false;
        });
    },
    excluirMovimentacaoDialog(item) {
      this.aplSelecionada = item;
      console.log(this.aplSelecionada);
      this.resetarDialog();
      this.textoDialog =
        "Deseja realmente excluir essa Movimentação (Apólice: " +
        this.aplSelecionada.apl +
        ")?";
      this.botaoExcluirMovimento = true;
      this.dialog = true;
    },
    excluirMovimentacao() {
      this.resetarDialog();
      this.fullLoading = true;
      let codigoCorretor = this.usuario.codCorretor;
      let url =
        "MovimentoVida/excluir-movimentacao/" +
        this.aplSelecionada.emissaoPendente +
        "/" +
        this.aplSelecionada.apl;

      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          this.showToast("success", "Sucesso!", "Movimentação excluída com sucesso.");
          //console.log(res.data);
          this.aplSelecionada = [];
          this.fullLoading = false;
          this.requestVidas();
        })
        .catch((error) => {
          //console.log(error.response.data);
          this.showToast("error", "Erro!", error.response.data);
          this.aplSelecionada = [];
          this.fullLoading = false;
        });
    },
    showUploadExcel(value) {
      this.verificarMovimentacaoRealizada(value)
        .then((result) => {
          console.log("result", result);
          if (result == true) {
            this.showToast("warning", "Atenção!", "Essa movimentação já foi realizada");
            return;
          } else {
            console.log("retorno value", value);
            this.vidasApoliceSelecionada = [value];
            //console.log(value.required);
            this.camposObrigatorios =
              value.required !== null ? value.required.split(";") : [];

            for (let index in this.camposObrigatorios) {
              this.camposObrigatorios[index] = this.camposObrigatorios[
                index
              ].toUpperCase();
            }
            console.log("this.camposObrigatorios");
            console.log(this.camposObrigatorios);

            this.visibleList = false;
            this.visibleUpload = true;
            if (
              value.idTipoApl !== null &&
              (value.idTipoApl == 1 || value.idTipoApl == 3)
            ) {
              if (value.idTipoApl == 3) {
                this.tipoRelacaoList = [{ text: "Averbados", value: 3 }];
                this.tipoRelacao = 3;
              }

              if (value.idTipoApl == 1) {
                this.tipoRelacaoList = [{ text: "Prestamista", value: 4 }];
                this.tipoRelacao = 4;
              }
            } else {
              this.tipoRelacaoList = [
                { text: "Relação Completa", value: 1 },
                { text: "Apenas Movimentação", value: 2 },
              ];
            }
          }
        })
        .catch((error) => console.log(error));
    },
    uploadExcel() {
      this.fullLoading = true;

      this.popularTipoColuna();
      this.marcaCamposObrigatorios();

      if (this.tipoRelacao == null) {
        this.fullLoading = false;
        this.showToast("warning", "Atenção!", "Selecione o tipo de relação.");
        return;
      }

      if (this.fileExcel == null) {
        this.fullLoading = false;
        this.showToast("warning", "Atenção!", "Selecione o arquivo para upload.");
        return;
      }

      let formData = new FormData();
      let apoliceSelecionada = this.vidasApoliceSelecionada[0];
      formData.append("Apl", apoliceSelecionada.apl);
      formData.append("TipoMovimentacao", this.tipoRelacao);

      formData.append("File", this.fileExcel);

      Vue.prototype.$httpPortal
        .post("MovimentoVida/processar-excel", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (
            apoliceSelecionada.idTipoApl !== null &&
            (apoliceSelecionada.idTipoApl == 1 || apoliceSelecionada.idTipoApl == 3)
          ) {
            this.showToast("success", "Sucesso!", "Movimentação realizada com sucesso.");
            this.requestVidas();
          } else {
            this.planilhaEnviada = res.data;

            this.tipoColunaList = [];
            for (let i = 0; i < Object.keys(this.planilhaEnviada[0]).length; i++) {
              this.tipoColunaList.push({ opcoes: this.tipoColuna, value: "" });
            }

            this.visibleUpload = false;
            this.visibleConfiguracaoPlanilha = true;
            this.fullLoading = false;
          }
        })
        .catch((res) => {
          console.log("error", "Erro!", res.response.data);
          this.showToast("error", "Erro!", "Erro no upload.");
          this.fullLoading = false;
        });
    },
    processarVidas() {
      debugger;
      this.fullLoading = true;

      if (this.linha == null) {
        this.fullLoading = false;
        this.showToast(
          "warning",
          "Atenção!",
          "Selecione a linha inicial para importação das vidas."
        );
        return;
      }
      let vidasConfiguradas = [];
      let vidasComLinhaInicial = this.planilhaEnviada.slice(this.linha - 1);
      for (let row in vidasComLinhaInicial) {
        let importacaoVida = {
          NOME: null,
          NOME_SOCIAL: null,
          SEXO: null,
          CPF: null,
          ENDERECO: null,
          CEP: null,
          DATA_NASCIMENTO: null,
          SALARIO: null,
          TIPO_MOVIMENTACAO: this.tipoRelacao,
          LINHA_INICIAL: this.linha,
          RG: null,
          ORGAO_EXP: null,
          DATA_EXP: null,
          MATRICULA: null,
          ESTADO_CIVIL: null,
          EMAIL: null,
          PROFISSAO: null,
          TIPO_MOVIMENTO: null,
        };

        for (let i = 0; i < Object.keys(vidasComLinhaInicial[row]).length; i++) {
          if (JSON.stringify(vidasComLinhaInicial[row]).includes("Column")) {
            importacaoVida[this.tipoColunaList[i].value] = this.verificarCampoData(
              vidasComLinhaInicial[row]["Column" + i]
            );
          } else {
            importacaoVida[this.tipoColunaList[i].value] = this.verificarCampoData(
              vidasComLinhaInicial[row]["coluna" + (i + 1)]
            );
          }
        }
        vidasConfiguradas.push(importacaoVida);
      }

      let apoliceSelecionada = this.vidasApoliceSelecionada[0];
      let codigoCorretor = this.usuario.codCorretor;
      let emailUsuario =
        this.usuario.emailAuxiliar != null && this.usuario.emailAuxiliar != ""
          ? this.usuario.emailAuxiliar
          : this.usuario.email;
      let url = "";
      if (vidasConfiguradas.length > 1000) {
        this.salvarDados = true;
        url =
          "MovimentoVida/importar-vidas/" +
          codigoCorretor +
          "/" +
          apoliceSelecionada.apl +
          "/" +
          emailUsuario +
          "/" +
          this.salvarDados;
      } else {
        url =
          "MovimentoVida/importar-vidas/" +
          codigoCorretor +
          "/" +
          apoliceSelecionada.apl +
          "/" +
          emailUsuario +
          "/" +
          this.salvarDados;
      }

      Vue.prototype.$httpPortal
        .post(url, vidasConfiguradas)
        .then((res) => {
          this.resetarDialog();
          
          if (vidasConfiguradas.length <= 1000 && !this.salvarDados) {
            console.log("⚡ Fazendo segunda chamada automática: arquivo < 1000 registros sem erros");
            this.salvarDados = true;
            this.processarVidas();
            return;
          } else if (this.salvarDados === true && vidasConfiguradas.length > 1000) {
            this.showToast(
              "success",
              "Sucesso!",
              "Os dados enviados com sucesso. Passarão por análise e um retorno será dado em até 3 dias."
            );
            this.requestVidas();
          } else if (this.salvarDados === true && vidasConfiguradas.length <= 1000) {
            this.showToast("success", "Sucesso!", "Movimentação realizada com sucesso.");
            this.requestVidas();
          }

          this.fullLoading = false;
        })
        .catch((error) => {
          this.showToast("error", "Erro!", "Há problemas detectados");
          console.log(error.response.data);
          this.retornoProcessamento = error.response.data.processo;
          this.erroLista = this.retornoProcessamento.erros;
          this.registrosValidos =
            this.retornoProcessamento.totalRegistro -
            this.retornoProcessamento.totalRegistroInvalido;
          this.registrosInvalidos = this.retornoProcessamento.totalRegistroInvalido;

          this.fullLoading = false;
          this.showErroLista = true;
        });
      console.log("vidas configuradas", vidasConfiguradas);
    },
    cancelarProcessamento() {
      this.visibleConfiguracaoPlanilha = false;
      this.visibleUpload = true;
    },
    cancelarUpload() {
      this.requestVidas();
    },
    marcaCamposObrigatorios() {
      for (let item1 in this.tipoColuna) {
        for (let item2 in this.camposObrigatorios) {
          if (this.tipoColuna[item1].value == this.camposObrigatorios[item2])
            this.tipoColuna[item1].text += "*";
        }
      }
    },
    popularTipoColuna() {
      if (this.tipoRelacao == 1) {
        this.tipoColuna = [
          { value: null, text: "Sem Associação" },
          { value: "NOME", text: "Nome" },
          { value: "NOME_SOCIAL", text: "Nome Social" },
          { value: "CPF", text: "CPF" },
          { value: "DATA_NASCIMENTO", text: "Data Nascimento" },
          { value: "SALARIO", text: "Salario" },
          { value: "SEXO", text: "Sexo" },
          { value: "MATRICULA", text: "Matricula" },
          { value: "CEP", text: "Cep" },
          { value: "ENDERECO", text: "Endereço" },
          { value: "RG", text: "RG" },
          { value: "ORGAO_EXP", text: "Orgão Expedição" },
          { value: "DATA_EXP", text: "Data Expedição" },
          { value: "ESTADO_CIVIL", text: "Estado Civil" },
        ];
      } else {
        this.camposObrigatorios.push("TIPO_MOVIMENTO");

        this.tipoColuna = [
          { value: null, text: "Sem Associação" },
          { value: "NOME", text: "Nome" },
          { value: "NOME_SOCIAL", text: "Nome Social" },
          { value: "CPF", text: "CPF" },
          { value: "DATA_NASCIMENTO", text: "Data Nascimento" },
          { value: "SALARIO", text: "Salario" },
          { value: "SEXO", text: "Sexo" },
          { value: "MATRICULA", text: "Matricula" },
          { value: "CEP", text: "Cep" },
          { value: "ENDERECO", text: "Endereço" },
          { value: "RG", text: "RG" },
          { value: "ORGAO_EXP", text: "Orgão Expedição" },
          { value: "DATA_EXP", text: "Data Expedição" },
          { value: "ESTADO_CIVIL", text: "Estado Civil" },
          { value: "TIPO_MOVIMENTO", text: "Tipo Movimento" },
        ];
      }
    },
    tipoColunaSelecionada(value) {
      let valoresSelecionados = [];
      for (let coluna in this.tipoColunaList) {
        if (
          this.tipoColunaList[coluna].value !== null &&
          this.tipoColunaList[coluna].value != ""
        ) {
          valoresSelecionados.push(this.tipoColunaList[coluna].value);
        }
      }

      //console.log(valoresSelecionados);

      for (let coluna in this.tipoColunaList) {
        let _valorAtual = this.tipoColunaList[coluna].value;
        //console.log("valor atual :" + _valorAtual)
        this.tipoColunaList[coluna].opcoes = this.tipoColuna.filter(function (obj) {
          if (_valorAtual === null || _valorAtual == "") {
            return valoresSelecionados.indexOf(obj.value) == -1;
          } else {
            return (
              valoresSelecionados.indexOf(obj.value) == -1 || obj.value == _valorAtual
            );
          }
        });
      }
    },
    importarDados() {
      this.resetarDialog();
      this.showErroLista = false;
      this.salvarDados = true;
      this.processarVidas();
    },
    alterarMovimentacaoAutomatica(item) {
      this.fullLoading = true;
      let codigoCorretor = this.usuario.codCorretor;
      let url =
        "MovimentoVida/movimentacao-automatica/" +
        codigoCorretor +
        "/" +
        item.apl +
        "/" +
        item.emissaoPendente +
        "/" +
        item.movimentacaoAutomatica;

      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          //window.open(res.data, "_blank");
          //console.log(res.data);
          this.fullLoading = false;
        })
        .catch((error) => {
          this.showToast("error", "Erro!", error.response);
          this.fullLoading = false;
        });
    },
    emitirArquivoErro() {
      let codigoCorretor = this.usuario.codCorretor;
      let apoliceSelecionada = this.vidasApoliceSelecionada[0];
      let _nomeArquivo = this.fileExcel.name;
      let url =
        Vue.prototype.$httpPortal.defaults.baseURL +
        "MovimentoVida/mov-vidas-arquivo-erro";
      this.retornoProcessamento.competencia = apoliceSelecionada.emissaoPendente;
      this.retornoProcessamento.nomeArquivo = this.fileExcel.name;
      this.fullLoading = true;
      Vue.prototype.$httpPortal
        .post(url, this.retornoProcessamento)
        .then((res) => {
          this.fullLoading = false;
          let _identificador = res !== undefined ? res.data : "";
          if (_identificador.length > 0) {
            let urlDownload =
              Vue.prototype.$httpPortal.defaults.baseURL +
              "Emissao/arquivo-erro/" +
              _identificador;
            window.open(urlDownload, "_blank");
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          console.log(error);
          this.showToast("error", "Erro!", "Ocorreu um problema, contate a Previsul. ");
        });
    },
  },
  computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" }),
  },
  filters: {
    formatDateBR(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
  mounted() {
    this.requestVidas();
  },
};
</script>

<style lang="scss">
.select-tipo-coluna {
  min-width: 250px;
}
.v-data-table.border {
  overflow: auto !important;
  max-height: 400px;
  td,
  th {
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }
  th {
    border-top: 1px solid #dddddd;
    background: #eeeeee;
    padding-top: 30px;
  }
  .v-data-table__wrapper {
    overflow-x: auto !important;
    overflow-y: auto !important;
    max-height: 400px;
  }
}
.alert {
  color: #ffffff;
  padding: 10px;
  margin: 2px;
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  &.enviado {
    background: #76ab3c;
  }
  &.processando {
    background: #2a4469;
  }
  &.faturado {
    background: #4fb5dd;
  }
  &.sem-movimentacao {
    background: #555555;
  }
  &.alert-error {
    background: #d32f2f;
    transition: all 0.3s ease;
    &:hover {
      background: #b71c1c;
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
  }
}
.text-alert .v-label {
  color: #f44336;
}
.text-mono {
  font-family: "Courier New", monospace;
}
</style>
